import React, { useState, useEffect } from 'react'
import { User } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import './Header.styles.scss'
import logo from '../assets/wlogo.png'

export default function Header() {
  const { user, logout } = useAuth()
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000)
    return () => clearInterval(timer)
  }, [])

  const dateStr = now.toLocaleDateString(undefined, {
    weekday: 'short',
    month:   'short',
    day:     'numeric',
    year:    'numeric'
  })
  const timeStr = now.toLocaleTimeString(undefined, {
    hour:   '2-digit',
    minute: '2-digit'
  })

  return (
    <header className="app-header">
      <div className="logo">
        <img src={logo} alt="Logo" />
      </div>

      <div className="header-center">
        <div className="date">{dateStr}</div>
        <div className="time">{timeStr}</div>
      </div>

      <div className="account-menu">
        <User className="account-icon" />
        <ul className="dropdown">
          <li className="dropdown-item">Account</li>
          <li className="dropdown-item">Preferences</li>
          <li className="dropdown-item" onClick={logout}>Logout</li>
        </ul>
      </div>
    </header>
  )
}
